/* ==========================================================================
   GLOBAL — drawer'lar, sepet AJAX, predictive search, giriş animasyonu
   Vanilla JS. Framework yok.

   Sepet istekleri SIRAYA ALINIR: hızlı ardışık tıklamada yanıtlar birbirini
   ezmesin diye tek bir promise zinciri üzerinden gider.
   ========================================================================== */

(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || {};

  /* ---------------------------------------------------------------- Drawer */

  var Drawer = {
    active: null,
    lastFocus: null,

    open: function (name) {
      var el = document.querySelector('[data-drawer="' + name + '"]');
      if (!el) return;
      Drawer.lastFocus = document.activeElement;
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-drawer-open');
      Drawer.active = el;

      var focusable = el.querySelector('input, button, a[href]');
      if (focusable) {
        window.setTimeout(function () { focusable.focus(); }, 60);
      }
    },

    close: function () {
      if (!Drawer.active) return;
      Drawer.active.classList.remove('is-open');
      Drawer.active.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-drawer-open');
      Drawer.active = null;
      if (Drawer.lastFocus) Drawer.lastFocus.focus();
    }
  };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-drawer]');
    if (opener) {
      e.preventDefault();
      Drawer.open(opener.getAttribute('data-open-drawer'));
      return;
    }
    if (e.target.closest('[data-close-drawer]')) {
      e.preventDefault();
      Drawer.close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') Drawer.close();
  });

  /* ------------------------------------------------------- Açılır alt menü */

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-submenu-toggle]');
    var openMenus = document.querySelectorAll('[data-submenu-toggle][aria-expanded="true"]');

    if (!toggle) {
      for (var i = 0; i < openMenus.length; i++) closeSubmenu(openMenus[i]);
      return;
    }

    e.preventDefault();
    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    for (var j = 0; j < openMenus.length; j++) closeSubmenu(openMenus[j]);
    if (!isOpen) {
      toggle.setAttribute('aria-expanded', 'true');
      var panel = toggle.parentElement.querySelector('.submenu');
      if (panel) panel.hidden = false;
    }
  });

  function closeSubmenu(toggle) {
    toggle.setAttribute('aria-expanded', 'false');
    var panel = toggle.parentElement.querySelector('.submenu');
    if (panel) panel.hidden = true;
  }

  /* ------------------------------------------------------------------ Sepet */

  var Cart = {
    queue: Promise.resolve(),

    /* Tüm sepet istekleri buradan geçer — sıralı çalışır, son yanıt kazanır
       diye ara durum kaybolmaz. */
    enqueue: function (task) {
      Cart.queue = Cart.queue.then(task).catch(function (err) {
        Cart.showError(err && err.message ? err.message : theme.strings.add_to_cart_error);
      });
      return Cart.queue;
    },

    request: function (url, body) {
      body.sections = 'cart-drawer';
      body.sections_url = window.location.pathname;

      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            /* 422: stok tükendi / geçersiz adet. Shopify description döner. */
            var message = data.description || data.message || theme.strings.add_to_cart_error;
            throw new Error(message);
          }
          return data;
        });
      });
    },

    render: function (data) {
      if (!data || !data.sections || !data.sections['cart-drawer']) return;

      var parsed = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
      var fresh = parsed.querySelector('[data-cart-section]');
      var current = document.querySelector('[data-cart-section]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;

      var countEl = document.querySelector('[data-cart-count-value]');
      var badge = document.querySelector('[data-cart-count]');
      if (countEl && badge) {
        var count = parseInt(countEl.getAttribute('data-cart-count-value'), 10) || 0;
        badge.textContent = count;
        badge.hidden = count === 0;
      }
    },

    showError: function (message) {
      var target = document.querySelector('[data-cart-error]');
      if (target) {
        target.textContent = message;
        target.hidden = false;
        return;
      }
      var formError = document.querySelector('[data-product-form-error]');
      if (formError) {
        formError.textContent = message;
        formError.hidden = false;
      }
    },

    clearError: function () {
      var nodes = document.querySelectorAll('[data-cart-error], [data-product-form-error]');
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].textContent = '';
        nodes[i].hidden = true;
      }
    }
  };

  /* Sepete ekle */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.product-form');
    if (!form) return;

    e.preventDefault();
    Cart.clearError();

    var button = form.querySelector('[type="submit"]');
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    if (!idInput || !idInput.value) return;

    if (button) button.disabled = true;

    Cart.enqueue(function () {
      return Cart.request(routes.cart_add_url + '.js', {
        items: [{ id: Number(idInput.value), quantity: Number(qtyInput ? qtyInput.value : 1) }]
      }).then(function (data) {
        Cart.render(data);
        Drawer.open('cart');
      }).finally(function () {
        if (button) button.disabled = false;
      });
    });
  });

  /* Sepette adet değiştir / kaldır */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-change]');
    if (!btn) return;

    e.preventDefault();
    Cart.clearError();

    var line = btn.getAttribute('data-line');
    var quantity = Number(btn.getAttribute('data-cart-change'));
    var row = btn.closest('[data-cart-item]');
    if (row) row.classList.add('is-busy');

    Cart.enqueue(function () {
      return Cart.request(routes.cart_change_url + '.js', {
        line: Number(line),
        quantity: quantity
      }).then(function (data) {
        Cart.render(data);
      });
    });
  });

  /* Adet input'u (ürün sayfası) */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;

    e.preventDefault();
    var wrap = step.closest('[data-qty]');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    if (!input) return;

    var min = Number(input.getAttribute('min') || 1);
    var next = Number(input.value) + Number(step.getAttribute('data-qty-step'));
    input.value = next < min ? min : next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------ Predictive search */

  var search = {
    controller: null,
    timer: null
  };

  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-search-input]');
    if (!input) return;

    var results = document.querySelector('[data-search-results]');
    if (!results) return;

    var term = input.value.trim();

    window.clearTimeout(search.timer);
    if (search.controller) search.controller.abort();

    if (term.length < 2) {
      results.innerHTML = '';
      return;
    }

    search.timer = window.setTimeout(function () {
      search.controller = new AbortController();

      var url = routes.predictive_search_url +
        '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection,page' +
        '&resources[limit]=6' +
        '&section_id=predictive-search';

      fetch(url, { signal: search.controller.signal })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-search-payload]');
          results.innerHTML = fresh ? fresh.innerHTML : '';
        })
        .catch(function (err) {
          if (err.name !== 'AbortError') results.innerHTML = '';
        });
    }, 250);
  });

  /* --------------------------------------------------------- Hero slider */

  /* İlk slayt HTML'de aktif geldiği için JS çalışmasa da görsel durur.
     Noktalar JS ile üretilir — script yoksa ölü kontrol görünmez. */

  function initHeroSlider() {
    var root = document.querySelector('[data-hero-slider]');
    if (!root) return;
    if (root.getAttribute('data-inited') === 'true') return;

    var slides = root.querySelectorAll('[data-hero-slide]');
    if (slides.length < 2) return;

    root.setAttribute('data-inited', 'true');

    var index = 0;
    var timer = null;
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 6000;
    var dotsWrap = root.querySelector('[data-hero-dots]');
    var dots = [];

    if (dotsWrap) {
      for (var d = 0; d < slides.length; d++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hero-slider__dot' + (d === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', String(d + 1));
        dot.addEventListener('click', (function (target) {
          return function () { stop(); go(target); start(); };
        })(d));
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
    }

    function go(next) {
      index = (next + slides.length) % slides.length;
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle('is-active', i === index);
        if (dots[i]) dots[i].classList.toggle('is-active', i === index);
      }
    }

    function start() {
      if (theme.designMode) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stop();
      timer = window.setInterval(function () { go(index + 1); }, speed);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    if (prev) prev.addEventListener('click', function () { stop(); go(index - 1); start(); });
    if (next) next.addEventListener('click', function () { stop(); go(index + 1); start(); });

    /* Üzerine gelince durur, sekme arka plana geçince durur */
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    start();
  }

  /* ------------------------------------------------------------ Öneriler */

  function initRecommendations() {
    var holder = document.querySelector('[data-recommendations]');
    if (!holder) return;
    if (holder.getAttribute('data-loaded') === 'true') return;

    var url = holder.getAttribute('data-url');
    if (!url) return;

    holder.setAttribute('data-loaded', 'true');

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-recommendations]');
        if (fresh) holder.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* öneri gelmezse bölüm boş kalır, sayfa bozulmaz */ });
  }

  /* ------------------------------------------------------- Koleksiyon filtre */

  /* Filtre veya sıralama değişince formu gönder — GET, sayfa yenilenir.
     JS yoksa noscript'teki "Apply" butonu aynı işi görür. */
  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-facets]');
    if (!form) return;
    form.submit();
  });

  /* ---------------------------------------------------- Giriş animasyonları */

  /* Kural: içerik JS'in arkasına saklanmaz. .js sınıfı yoksa her şey görünür.
     Tema editöründe kapalı — yarım kalmış animasyon merchant'a bozuk görünür. */

  function initReveal() {
    if (theme.designMode) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var items = document.querySelectorAll('[data-reveal]');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      showAll(items);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

    for (var i = 0; i < items.length; i++) {
      var rect = items[i].getBoundingClientRect();
      /* Ekranda olanı gözlemci beklemeden hemen göster */
      if (rect.top < window.innerHeight) {
        items[i].classList.add('is-revealed');
      } else {
        observer.observe(items[i]);
      }
    }

    /* Güvenlik ağı: 3 saniye sonra ne olursa olsun her şey görünür */
    window.setTimeout(function () { showAll(items); }, 3000);
  }

  function showAll(items) {
    for (var i = 0; i < items.length; i++) items[i].classList.add('is-revealed');
  }

  /* ------------------------------------------------------- Sayan rakamlar */

  /* Sadece tamamen rakamdan oluşan değerlerde çalışır ("44" evet, "2–4 weeks"
     hayır). JS yoksa veya animasyon kapalıysa sayı olduğu gibi durur. */

  function initCountUp() {
    var nodes = document.querySelectorAll('[data-countup]');
    if (!nodes.length) return;
    if (theme.designMode) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        countTo(entry.target);
      });
    }, { threshold: 0.4 });

    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-counted') === 'true') continue;
      if (!/^\d+$/.test(nodes[i].textContent.trim())) continue;
      observer.observe(nodes[i]);
    }
  }

  function countTo(el) {
    el.setAttribute('data-counted', 'true');
    var target = parseInt(el.textContent.trim(), 10);
    if (!target) return;

    var duration = 900;
    var started = null;

    function step(now) {
      if (started === null) started = now;
      var progress = Math.min((now - started) / duration, 1);
      /* ease-out: sona doğru yavaşlar */
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(target * eased);
      if (progress < 1) window.requestAnimationFrame(step);
      else el.textContent = target;
    }

    el.textContent = '0';
    window.requestAnimationFrame(step);
  }

  function init() {
    initReveal();
    initCountUp();
    initHeroSlider();
    initRecommendations();
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  /* Tema editöründe section yeniden yüklendiğinde tekrar bağla */
  document.addEventListener('shopify:section:load', init);
})();
